import React, {Suspense} from 'react';
import { translateTryKeys } from "../../translate";

export default function PageFrame({ children, pageName }) {
    return (
        <>
            <h1>{translateTryKeys(pageName, 'pagetitle', 'toolname')}</h1>
            {children}
        </>
    )
}
